/**
 * Created On : 7th Feb 2018
 * Usage : Displays data and Warnings of the Chillers according to the timeline along with timestamp
 * Coprights : Johnson Controls India Pvt Ltd.
 **/

import { Component, Input, EventEmitter, Output } from "@angular/core";
import { Alert } from "../../../models/alert.model";
import { Asset } from "../../../models/asset.model";


@Component({
    selector: 'alert-tab-card',
    styles: [`
    ion-card-header {
        font-size: 12px !important;
        background: #4378b5;
        color: #fff !important;
        border-top: 1px solid #555555;
        border-bottom: 1px solid #555555;
        padding-bottom: 4px !important;
        padding-top: 4px !important;
        font-weight: 100 !important;
        padding-left: 12px;
        padding-right: 124px;
    }
    .alert-ion-card {
        //box-shadow: 0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22) !important;
        box-shadow: 1px 1px 30px 0px #bcbcbc !important;
        margin: 0px 10px 5px 0px !important;;
        width: 100% !important;
    }
    div p:first-child{
        margin-left: 122px;
        color: #08338f;
        font-size: 12px;
        margin-bottom: 0;
        margin-top: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    div p:last-child {
        margin-left: 122px !important;
        color: #555555;
        font-size: 12px;
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 35px;
    }
    ion-card-content {
        margin-top: -9px;
    }
    span{
        margin-left:6px;
        margin-top:1px;
    }
    .concentric-circle {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 5px solid #666666;
        padding-top: 9.5px;
        background: #e5e5e5;
    }
    .margin-auto {
        margin: auto;
    }
    .title-blue {
        color: #4378b5;
    }
    .large-icons {
        font-size: 3rem;
        margin-top: 1.2rem;
    }
    .margin-top-12 {
        margin-top: 12px;
    }
     `],
    template: `
    <ion-card class="alert-ion-card" (tap)="redirectToTrendsPage(alert)">
        <ion-card-header text-left>{{alert.attributeName}}</ion-card-header>
            <ion-card-content padding>
                <ion-grid class="margin-top-12">
                    <ion-row>
                        <ion-col col-3 text-center class="margin-auto">
                            <div class="concentric-circle" [style.borderColor]="alert.colorcode">
                                {{alert.differernce}}
                            </div>
                        </ion-col>
                        <ion-col col-8 text-left>
                            <div class="title-blue">{{alert.tripstatus}}
                            <ion-icon float-right color="dark" class="large-icons" ios="ios-arrow-forward" md="md-ios-arrow-forward"></ion-icon></div>
                            <!-- <div>{{alert.attributeName}}</div> -->
                            <div>{{alert.timestamp}}</div>
                        </ion-col>

                    </ion-row>

                </ion-grid>
              
        </ion-card-content>
    </ion-card>`
})
export class AlertTabCard {

    @Input() alert: Alert;
    @Input() asset: Asset;
    @Input() project: any;
    @Output() showOnboardDiagnostics = new EventEmitter();

    constructor(){}

    redirectToTrendsPage(alert){
        this.showOnboardDiagnostics.emit(alert)
    }
}


// WEBPACK FOOTER //
// ./src/components/alerts/alert-components/alert-tab-card.component.ts